import { gatedFeatureFor } from '~/utils/planGatedRoutes'

// Plan-gated routes (MAR-199) need the org's plan KNOWN before they render: `pages/app.vue` decides
// between the page and the upgrade notice from `profile.feature_flags`, and a page that mounted while
// the profile was still loading would fire the very requests the plan refuses. So this waits for the
// profile on a gated path, and nothing else — it no longer redirects (MAR-980, decision D2: a gated
// route shows an in-page notice instead of silently bouncing to /app). The table is
// `app/utils/planGatedRoutes.ts`; the server's `requireFeature` remains the authoritative gate.
export default defineNuxtRouteMiddleware(async (to) => {
  if (!gatedFeatureFor(to.path)) return

  const { waitForAuth } = useAuth()
  const { ensure: ensureProfile } = useUserProfile()

  await waitForAuth()
  await ensureProfile()
})
